import { render, staticRenderFns } from "./CreateTemplateBank.vue?vue&type=template&id=53d4728f"
import script from "./CreateTemplateBank.vue?vue&type=script&lang=js"
export * from "./CreateTemplateBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports